/**
 * TotalCo — Meta Pixel custom events.
 * Does NOT touch the base pixel/init code (that lives in layout/theme.liquid).
 * Everything here just calls the already-initialized global fbq().
 *
 * Reliability notes (see chat for the full explanation):
 * - WhatsApp / bundle / "ver más reseñas" / scroll depth: 100% reliable, all
 *   hooked into markup this theme controls directly.
 * - Releasit COD form (Lead / Purchase / FormularioAbandonado): BEST EFFORT.
 *   Releasit is a third-party app embed that injects its own DOM at runtime —
 *   there is no theme file to read its real class/id names from, so detection
 *   here is a generic heuristic (any element whose id/class contains
 *   "releasit", added/removed from the page, or any <form> submitted inside
 *   one). This needs to be verified live (console.log lines are included on
 *   purpose) against the real rendered page before trusting the numbers.
 */
(function () {
  'use strict';

  function fire() {
    if (typeof window.fbq !== 'function') return;
    window.fbq.apply(window, arguments);
  }

  /* =========================================================
     1. WHATSAPP — any link whose href contains wa.me / whatsapp
     Selector: a[href*="wa.me"], a[href*="whatsapp"]
     Covers: .tc-whatsapp-float (floating button) and the footer link,
     both already point to wa.me — no extra markup change was needed.
     ========================================================= */
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('a[href]');
    if (!link) return;
    var href = link.href.toLowerCase();
    if (href.indexOf('wa.me') !== -1 || href.indexOf('whatsapp') !== -1) {
      fire('trackCustom', 'ClickWhatsApp', { content_name: 'Boton WhatsApp' });
    }
  });

  /* =========================================================
     2. BUNDLE / SELECTOR DE VARIANTES
     Selector: [data-tc-variant-option] (the radio-style option cards in
     snippets/totalco-bundle-picker.liquid)
     content_name = the real variant title (data-variant-title attribute).
     ========================================================= */
  document.addEventListener('click', function (evt) {
    var option = evt.target.closest('[data-tc-variant-option]');
    if (!option) return;
    var titleEl = option.querySelector('.tc-bundle__option-title');
    var title = option.dataset.variantTitle || (titleEl ? titleEl.textContent.trim() : 'Variante');
    fire('trackCustom', 'SeleccionBundle', { content_name: title });
  });

  /* =========================================================
     3. RESEÑAS — "Ver más reseñas"
     Selector: [data-tc-reviews-more]
     ========================================================= */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-tc-reviews-more]');
    if (!btn) return;
    fire('trackCustom', 'VerMasReseñas');
  });

  /* =========================================================
     4. SCROLL PROFUNDO — 50% / 75% / 90%, una vez por sesión (sessionStorage)
     No usa selector CSS: mide contra la altura total del documento.
     ========================================================= */
  (function () {
    var thresholds = [
      { pct: 50, key: 'tc_scroll_50', event: 'Scroll50' },
      { pct: 75, key: 'tc_scroll_75', event: 'Scroll75' },
      { pct: 90, key: 'tc_scroll_90', event: 'Scroll90' }
    ];

    function alreadyFired(key) {
      try {
        return sessionStorage.getItem(key) === '1';
      } catch (e) {
        return false;
      }
    }
    function markFired(key) {
      try {
        sessionStorage.setItem(key, '1');
      } catch (e) {}
    }

    var pending = thresholds.filter(function (t) {
      return !alreadyFired(t.key);
    });
    if (!pending.length) return;

    var ticking = false;
    function checkScroll() {
      ticking = false;
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var docHeight = Math.max(doc.scrollHeight, document.body.scrollHeight) - doc.clientHeight;
      if (docHeight <= 0) return;
      var scrolledPct = (scrollTop / docHeight) * 100;

      pending = pending.filter(function (t) {
        if (scrolledPct >= t.pct) {
          markFired(t.key);
          fire('trackCustom', t.event);
          return false;
        }
        return true;
      });

      if (!pending.length) {
        window.removeEventListener('scroll', onScroll);
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(checkScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    checkScroll();
  })();

  /* =========================================================
     5. FORMULARIO COD (Releasit) — best effort, ver nota arriba.
     Heurística: cualquier nodo cuyo id o class contenga "releasit".
     ========================================================= */
  (function () {
    var state = { open: false, submitted: false };

    function isReleasitNode(node) {
      if (!node || node.nodeType !== 1) return false;
      var id = (node.id || '').toLowerCase();
      var cls = '';
      if (typeof node.className === 'string') cls = node.className.toLowerCase();
      return id.indexOf('releasit') !== -1 || cls.indexOf('releasit') !== -1;
    }

    function containsReleasit(node) {
      if (isReleasitNode(node)) return true;
      if (node.querySelector) {
        return !!node.querySelector('[id*="releasit" i], [class*="releasit" i]');
      }
      return false;
    }

    function findReleasitAncestor(el) {
      var node = el;
      while (node && node !== document.body) {
        if (isReleasitNode(node)) return node;
        node = node.parentElement;
      }
      return null;
    }

    function getSelectedPrice() {
      var selected = document.querySelector('.tc-bundle__option.is-selected');
      if (!selected) selected = document.querySelector('[data-tc-variant-option]');
      var raw = selected ? parseFloat(selected.dataset.priceRaw) : NaN;
      return isNaN(raw) ? null : raw;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (state.open || node.nodeType !== 1) return;
          if (containsReleasit(node)) {
            state.open = true;
            state.submitted = false;
            console.log('[TotalCo Pixel] Releasit form detected (opened) ->', node);
            fire('track', 'Lead', { content_name: 'Formulario COD abierto' });
          }
        });
        mutation.removedNodes.forEach(function (node) {
          if (!state.open || state.submitted || node.nodeType !== 1) return;
          if (containsReleasit(node)) {
            console.log('[TotalCo Pixel] Releasit form detected (closed without submit) ->', node);
            fire('trackCustom', 'FormularioAbandonado');
            state.open = false;
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('submit', function (evt) {
      var container = findReleasitAncestor(evt.target);
      if (!container) return;
      state.submitted = true;
      state.open = false;
      var price = getSelectedPrice();
      console.log('[TotalCo Pixel] Releasit form submit detected, price ->', price);
      fire('track', 'Purchase', {
        value: price !== null ? price : 0,
        currency: 'COP',
        content_name: 'Pedido COD enviado'
      });
    });
  })();
})();
